var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSverticalplaced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1099,
    height: 199,
    viewBox: "0 0 1099 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M681.648 185.736C682.612 184.703 683.679 184.054 685.119 183.318C685.322 182.462 685.241 182.08 685.615 181.993C695.567 172.842 706.164 164.743 717.318 157.324L716.462 157.122L716.372 156.735C729.903 149.164 746.171 142.968 764.481 138.71C803.024 129.746 836.994 132.306 865.228 146.659C890.098 158.281 911.093 175.733 928.225 199.008L1098.3 199.008C1091.43 183.575 1083.63 168.638 1074.87 154.225C1052.56 116.776 1024.71 85.0351 990.976 59.0901C957.62 33.0639 919.362 15.4075 876.292 6.50885C832.844 -2.29424 785.7 -0.980584 734.944 10.8228C670.83 25.7331 618.359 54.4302 577.495 96.9152C572.169 101.776 567.984 107.976 563.316 113.886L563.229 113.513C562.55 114.072 561.884 114.628 561.001 116.043C560.614 116.133 560.321 116.602 560.038 117.076C559.364 117.627 559.161 118.483 558.863 118.961C555.662 122.518 551.967 127.401 548.936 131.729C536.073 152.137 523.421 174.086 511.268 198.959L669.728 198.959C673.54 194.474 677.51 190.064 681.648 185.736Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.357 163.26C222.429 145.69 163.366 144.141 100.781 158.703C63.8011 167.303 30.1499 180.732 -0.00243467 198.959L177.583 198.959L355.169 198.959C331.635 183.782 306.073 171.856 278.357 163.26Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSverticalplaced);
export default __webpack_public_path__ + "static/media/sverticalplaced.99dea2ca96efad9561c5dba3d57a4ec9.svg";
export { ForwardRef as ReactComponent };